<template>
  <section id="hardware">
    <div class="wrap">
      <div class="head c">
        <h2 class="h2">What you need</h2>
      </div>
      <div class="needs mt">
        <div class="card need">
          <span class="tag" style="background:var(--live-bg);color:var(--live)">Free trial</span>
          <h3>Android media player</h3>
          <p>Contact us to start a free trial on an Android player.</p>
          <ul class="ticks"><li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>Set up in minutes</li><li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>Good for TVs and commercial LCDs</li></ul>
          <a class="btn btn-red btn-sm" href="#demo" data-demo="trial">Start a free trial</a>
        </div>
        <div class="card need">
          <span class="tag" style="background:var(--p-blue);color:#1E3A8A">Most networks</span>
          <h3>LCD with an Adverpost player</h3>
          <p>A dedicated player that keeps playing offline.</p>
          <ul class="ticks"><li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>Offline playback</li><li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>Remote brightness and rotation</li></ul>
          <a class="btn btn-line btn-sm" href="#demo" data-demo="lcd">Ask about players</a>
        </div>
        <div class="card need">
          <span class="tag">Commercial LED</span>
          <h3>Commercial LED</h3>
          <p>Run your own LED signs, or take over existing ones.</p>
          <ul class="ticks"><li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>Players from around $249</li><li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>Works with common LED senders</li></ul>
          <a class="btn btn-line btn-sm" href="#demo" data-demo="led">Talk to us about LED</a>
        </div>
      </div>
    </div>
  </section>
</template>

<script> 
// Extracted from the published landing page; in-page anchors emit instead of
// navigating, because the app uses a hash router.
export default { name: "HardwareSection" };
</script>
